import { useAuth } from "../../hooks/useAuth";
import { useLocation, useNavigate } from "react-router";
import AuthLayout from "./AuthLayout";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { EyeClosed, Eye, CircleNotch } from "@phosphor-icons/react";
import { useMutation } from "@tanstack/react-query";
import { loginFn } from "../../api/auth";
import clsx from "clsx";
import { toast } from "react-toastify";
import DeactivatedNotice from "./DeactivatedNotice";
import {
  getDeactivatedEmail,
  isDeactivatedError,
  setDeactivatedEmail,
} from "../../utils/deactivated";

export interface ILoginForm {
  email: string;
  password: string;
}

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const [isVisible, setIsVisible] = useState(false);
  // null → bildirim yok; string → hesap deaktif (email bilinmiyorsa boş)
  const [deactivatedEmail, setDeactivatedEmailState] = useState<string | null>(getDeactivatedEmail);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<ILoginForm>({
    mode: "onChange",
    /* defaultValues: {
      email: "omer@code2work.co",
      password: "1234",
    }, */
  });

  // Kullanıcı giriş yaptıktan sonra geldiği sayfaya geri dön
  const from = location.state?.from?.pathname || "/dashboard";

  const loginMutation = useMutation({
    mutationFn: loginFn,
    onSuccess: (userData) => {
      setDeactivatedEmail(null);
      login(userData);
      navigate(from, { replace: true });
      toast.success("Hoş geldin, ana sayfaya yönlendiriyorum.");
    },
    onError: (error, variables) => {
      console.error("Giriş başarısız", error);
      if (isDeactivatedError(error)) {
        const email = variables.email.trim().toLowerCase();
        setDeactivatedEmail(email);
        setDeactivatedEmailState(email);
        return;
      }
      toast.error("Giriş başarısız, email ya da şifren yanlış.");
    },
  });

  const handleLogin = (formData: ILoginForm) => {
    loginMutation.mutate(formData);
  };

  return (
    <AuthLayout title="Giriş yap">
      {deactivatedEmail !== null && <DeactivatedNotice email={deactivatedEmail} />}
      <form className="auth-form" onSubmit={handleSubmit(handleLogin)}>
        <label
          className={clsx(
            "form-line",
            errors.email ? "text-myRose" : ""
          )}
        >
          <span className="form-lineHeader">
            <span className="form-label">Email</span>
            <span className="form-error">
              {errors.email && errors.email.message?.toString()}
            </span>
          </span>
          <input
            type="text"
            className="form-input"
            {...register("email", {
              required: "Sistemdeki emailini yaz",
              validate: {
                matchPattern: (v) =>
                  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(v) ||
                  "Geçerli bir email adresi yaz",
              },
            })}
          />
        </label>
        <label
          className={clsx(
            "form-line",
            errors.password ? "text-myRose" : ""
          )}
        >
          <span className="form-lineHeader">
            <span className="form-label">Şifre</span>
            <span className="form-error">
              {errors.password && errors.password.message?.toString()}
            </span>
          </span>
          <div className="relative">
            <input
              type={isVisible ? "text" : "password"}
              className="form-input font-moboto"
              {...register("password", { required: "Şifre zorunlu" })}
            />
            <span
              className="absolute top-0 right-0 h-full flex items-center pr-3 cursor-pointer z-[2] text-white/30 hover:text-white/60 transition-colors"
              onClick={() => setIsVisible(!isVisible)}
            >
              {isVisible ? (
                <EyeClosed size={18} weight="bold" />
              ) : (
                <Eye size={18} weight="bold" />
              )}
            </span>
          </div>
        </label>
        <div className="form-line">
          <button
            className="bg-myGreen hover:bg-myGreen/80 text-black h-12 text-sm w-full rounded-xl cursor-pointer flex items-center justify-center font-semibold transition-colors disabled:opacity-50"
            type="submit"
            disabled={loginMutation.isPending}
          >
            {loginMutation.isPending ? (
              <CircleNotch
                size={24}
                weight="bold"
                className="animate-spin block"
              />
            ) : (
              <span>Giriş Yap</span>
            )}
          </button>
        </div>
      </form>
    </AuthLayout>
  );
}
